import React, { useContext } from 'react'
import { Table } from 'components/common'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { TubularContext } from 'stores/TubularStore'
import { UserContext } from "../../stores/UserStore"
import { FaArrowRight } from 'react-icons/fa'
import moment from 'moment'
import styled from 'styled-components'

const DetailArrow = styled(FaArrowRight)`
  color: #777;
  cursor: pointer;
  transition: 0.5s;
   
   &:hover{
    color: #aaa;
   }
`

const SotTable = ({ data }) => {
    const history = useHistory()
    const { setValueData } = useContext(TubularContext)
    const { registryLogOld, registryLog } = useContext(UserContext)
    // let id = ''
    const getSot = (value) => {
        registryLogOld('getSotSearchData', '/tlh/home')
        registryLog('home', 'click', 'get_sot_search_data')
        setValueData(value)
        history.push("/sot/" + value)
    }

    // useEffect(() => {
    //     if (parseInt(searchResult) === 1) {
    //         history.push("/sot/" + id)
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [searchResult, history])

    const { t } = useTranslation()

    const columns = [
        {
            Header: t('tlh.home.tabs.sot').toUpperCase(),
            accessor: (row) => row.sot,
            id: 'sot',
        },
        {
            Header: t("tlh.search.customer"),
            accessor: (row) => row.customerId.split('.')[0],
            id: 'contract',
        },
        {
            Header: t('tlh.search.date'),
            accessor: (row) => moment(row.date).format("DD/MM/YYYY"),
            id: 'date',
        },
        {
            Header: 'See piece',
            accessor: (row) => {
                return (
                    <DetailArrow size="1rem" onClick={() => getSot(row.sot)} />
                )
            },
        }
    ]
    return (
        <Table width="100%" columns={columns} data={data} sortable paginated style={{ whiteSpace: 'nowrap', width: "100%" }}></Table>
    )

}

export default SotTable
